import React from "react";
import { ico1, ico2, ico3, ico4 } from "../..";

const cardData = [
  {
    id: 0,
    strg_name: "Framework Flexibility",
    strg_para:
      "We tailor every solution to your compliance, cloud, app, and network needs.",
    strg_img: ico1,
  },
  {
    id: 1,
    strg_name: "Top Industry Minds",
    strg_para:
      "Led by seasoned cybersecurity professionals with deep industry knowledge.",
    strg_img: ico2,
  },
  {
    id: 2,
    strg_name: "Proactive Risk Mitigation",
    strg_para:
      "We don’t wait for breaches, we prevent them through intelligent analysis.",
    strg_img: ico3,
  },
  {
    id: 3,
    strg_name: "Real-Time Monitoring",
    strg_para:
      "We provide continuous monitoring and immediate response to threats.",
    strg_img: ico4,
  },
];
function StrategyCard() {
  return (
    <>
      {cardData.map((items, index) => (
        <div className="col-md-5" key={index}>
          <div className="strgWrap">
            <div className="iconBox col-2">
              <img
                src={items.strg_img}
                alt={items.strg_name}
                className="img-fluid"
              />
            </div>
            <div className="contentBox col-10">
              <h5>{items.strg_name}</h5>
              <p>{items.strg_para}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default StrategyCard;
